'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('inOutStatus.ctrls', [])
    .controller('UserAvailabilityController', ['$scope', 'InOutStatusService', 'ClusterService', '$ioAlert', 'UserService', '$rootScope', '$modal', 'ModalService', 'TaskService', function($scope, InOutStatusService, ClusterService, $ioAlert, UserService, $rs, $modal, ModalService, TaskService){
        $scope.availableUsers = [];
        $scope.unavailableUsers = [];
        $scope.breakUsers = [];
        $scope.extendedAbsenceUsers = [];
        $scope.taskAssignments = [];
        $scope.selectedTasks = [];
        $scope.tableHide = true;
        $scope.workflowUserStatus = [
            {'id': '0', 'text': 'All'},
            {'id': '36', 'text': 'Available'},
            {'id': '37', 'text': 'Available on Break'},
            {'id': '38', 'text': 'Unavailable'},
            {'id': '39', 'text': 'Extended Absence'}
        ];
        $scope.searchStatus = 0;

        var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
            getAvailableUsers();
            getUnavailableUsers();
        });

        $scope.$on('$destroy', function() {
            clusterSelector();
        });

        $scope.refreshPage = function(){
            getAvailableUsers();
            getUnavailableUsers();
        };

        var getAvailableUsers = function(){
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching  User Availablity";
            var params = {
                "clusterIds[]": ClusterService.clusterIds
            };
            InOutStatusService.getAvailableUsers(params).then(function(success){
                var users = success.workflowUsers;
                $scope.availableUsers = [];
                $scope.breakUsers = [];
                for(var i = 0, len = users.length; i < len; i++){
                    if(users[i].status_id == 36){
                        $scope.availableUsers.push(users[i]);
                    }else{
                        $scope.breakUsers.push(users[i]);
                    }
                }
            }, function(error){
                $ioAlert.show('Error!', 'Could not get Available Users.', 'error');
            });
        };

        var getUnavailableUsers = function(){
            var params = {
                "clusterIds[]": ClusterService.clusterIds
            };
            InOutStatusService.getUnavailableUsers(params).then(function(success){
                $scope.unavailableUsers = [];
                $scope.extendedAbsenceUsers = [];
                var users = success.workflowUsers;
                for(var i = 0, len = users.length; i < len; i++){
                    if(users[i].status == "Unavailable"){
                        $scope.unavailableUsers.push(users[i]);
                    }else{
                        $scope.extendedAbsenceUsers.push(users[i]);
                    }
                }
                $rs.loadingInProgress = false;
                $scope.tableHide = false;
            }, function(error){
                $ioAlert.show('Error!', 'Could not get Unavailable Users.', 'error');
                $rs.loadingInProgress = false;
                $scope.tableHide = false;
            });
        };

        $scope.toggleForAvailable = function(ev, user) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');
                InOutStatusService.getOpenTaskAssignmentsForUser({'userId': user.user_id, 'clusterIds': ClusterService.clusterIds}).then(function(success) {
                    $scope.availableUsers[$scope.availableUsers.indexOf(user)].taskAssignments = success.taskAssignments.rows;
                }, function(error) {
                    console.log("Error getting task assignments for the current user");
                });
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        };
        $scope.toggleForUnavailable = function(ev, user) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');
                InOutStatusService.getOpenTaskAssignmentsForUser({'userId': user.user_id, 'clusterIds': ClusterService.clusterIds}).then(function(success) {
                    $scope.unavailableUsers[$scope.unavailableUsers.indexOf(user)].taskAssignments = success.taskAssignments.rows;
                }, function(error) {
                    console.log("Error getting task assignments for the current user");
                });
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        };
        $scope.toggleForBreak = function(ev, user) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');
                InOutStatusService.getOpenTaskAssignmentsForUser({'userId': user.user_id, 'clusterIds': ClusterService.clusterIds}).then(function(success) {
                    $scope.breakUsers[$scope.breakUsers.indexOf(user)].taskAssignments = success.taskAssignments.rows;
                }, function(error) {
                    console.log("Error getting task assignments for the current user");
                });
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        };
        $scope.toggleForExtendedAbsence = function(ev, user) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');
                InOutStatusService.getOpenTaskAssignmentsForUser({'userId': user.user_id, 'clusterIds': ClusterService.clusterIds}).then(function(success) {
                    $scope.extendedAbsenceUsers[$scope.extendedAbsenceUsers.indexOf(user)].taskAssignments = success.taskAssignments.rows;
                }, function(error) {
                    console.log("Error getting task assignments for the current user");
                });
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        };
        $scope.assignTaskAssignments = function(id, taskId) {
            var taskIds = [taskId];
            UserService.getUsersForQueues(id, ClusterService.clusterIds).then(function(success) {
                var modalInstance = $modal.open(
                    ModalService.returnModalType('reassign', {
                        data: {
                            items: UserService.users
                        }
                    })
                );
                modalInstance.result.then(function(user) {
                    TaskService.assignTaskAssignments(taskIds, user.id).then(function(success) {
                        var assigned_user_name = user.first_name + ' ' + user.last_name;
                        angular.forEach($scope.tasks, function(task) {
                            if (taskIds.indexOf(taskId) != -1) {
                                var index = taskIds.indexOf(taskId);
                                console.log(index);
                                user.taskAssignments.splice(index,1);
                                task.assigned_user_name = assigned_user_name;
                            }
                        });
                        getAvailableUsers();
                        getUnavailableUsers();
                        $ioAlert.show('', 'The selected tasks were successfully assigned to ' + assigned_user_name, 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    });
                }, function() {
                });
            }, function(error) {
                console.log("Error getting users for queue");
            });
        };

        var init = function() {
            $scope.loadFail = true;
            ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
            if ($rs.userRole.permissions == 'vendor' || $rs.userRole.permissions == 'vendor-restricted') {
                $scope.restrictOrders = true;
                $scope.isVendor = true;
            }
            if ($rs.userRole.permissions == 'superadmin' || $rs.userRole.permissions == 'adops,admin') {
                $scope.isAdmin = true;
            }
        };

        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    }])
    .filter('userStatusFilter', function () {
        return function (input, symbol, place) {
            if (symbol > 0) {
                var output = [];
                for (var i = 0, len = input.length; i < len; i++) {
                    if (input[i].status_id == symbol) {
                        output.push(input[i]);
                    }
                }
                return output;
            }
            return input;
        }
    });